const Button = ({ type = "button", ...props }) => {
  return (
    <input
      className="button button--primary"
      type={type}
      {...props}
    />
  );
};

export default Button;